import { render, staticRenderFns } from "./laywerhot.vue?vue&type=template&id=5b263c44&scoped=true&"
import script from "./laywerhot.vue?vue&type=script&lang=js&"
export * from "./laywerhot.vue?vue&type=script&lang=js&"
import style0 from "./laywerhot.vue?vue&type=style&index=0&id=5b263c44&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b263c44",
  null
  
)

export default component.exports